import styled from 'styled-components';

const UpdatedDesktopHeaderStyles = styled.section`
  width: 100%;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    padding: 0;
  }

  .top-section,
  .bottom-section {
    box-sizing: border-box;
  }

  .top-section {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 20px;
    background: ${props => props.theme.colors.grey6};
    padding: 0.625rem 1.25rem;
  }

  .nav-section-links {
    text-decoration: none;
    color: ${props => props.theme.colors.bedtime};
    font-size: 0.875rem;
    margin: 0;
    padding: 0;
  }

  .bottom-section {
    display: flex;
    width: 100%;
    background: ${props => props.theme.colors.white};
    padding: 0.625rem 1.25rem;
  }

  .logo {
    padding-right: 2.5rem;
  }

  .nav-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .nav-left,
  .nav-right {
    justify-content: space-between;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.875rem;
    font-family: ${props => props.theme.fonts.primary};
  }

  .nav-right {
    margin-left: auto;
  }

  .nav-item {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 1.25rem;
    color: black;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: ${props => props.theme.colors.grey6};
    }
  }

  .dropdown,
  .sign-in-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 200px;
    background-color: white;
    display: none;
    white-space: nowrap;
  }
  .sign-in-dropdown {
    top: 102%;
  }

  .dropdown-title {
    font-size: ${props => props.theme.type.paragraph.xs};
    color: ${props => props.theme.colors.grey2};
    text-decoration: none;
  }

  .dropdown.active,
  .sign-in-dropdown.active {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;
    padding: 1.875rem 2.5rem;
    cursor: default;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
  }

  .dropdown.active {
    border-top: 2px solid ${props => props.theme.colors.grey6};
  }

  .dropdown-header {
    color: ${props => props.theme.colors.grey2};
    font-size: 0.75rem;
  }

  .dropdown-link {
    display: block;
    text-decoration: none;
    font-size: 0.875rem;
    color: ${props => props.theme.colors.black};
  }

  .dropdown-link:hover {
    background-color: #f5f5f5;
  }

  .nav-empty {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background: ${props => props.theme.colors.grey6};
    }
  }

  .sign-in {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    font-size: 0.875rem;
    font-family: ${props => props.theme.fonts.primary};
    font-weight: 600;
    color: ${props => props.theme.colors.black};
  }

  .sign-in-item {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 1.25rem;
    cursor: pointer;
    justify-content: space-between;
    gap: 10px;
    padding: 0.625rem 1.125rem;
    border: 1px solid ${props => props.theme.colors.white};

    &:hover {
      border: 1px solid ${props => props.theme.colors.bedtime};
    }
  }

  .sign-in-dropdown-link {
    font-size: 1rem;
    color: ${props => props.theme.colors.grey1};
    text-decoration: none;
    font-weight: 400;

    &:hover {
      background: ${props => props.theme.colors.grey6};
    }
  }

  .button-links {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
`;

export default UpdatedDesktopHeaderStyles;
